import React, { FC } from 'react';
import { Tooltip } from '@wix/design-system';
import { Collections } from '@wix/wix-ui-icons-common';
import { FormattedMessage } from 'react-intl';
import { ItemActionButton } from '../../../../common/ItemActionsRow/ItemActionButton/ItemActionButton';

type RelatedItemsButtonProps = { onClick: (e) => void };

export const RelatedItemsButton: FC<RelatedItemsButtonProps> = ({ onClick }) => {
  return (
    <Tooltip content={<FormattedMessage id="related.images.hover-and-title" />}>
      <ItemActionButton onClick={onClick} dataHook="related-content-button">
        <Collections />
      </ItemActionButton>
    </Tooltip>
  );
};
